// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=.ts"
// @generated from file qliq_protobuf/apps/pc/request/form_submission/complete_form.proto (package qliq_protobuf.apps.pc.request.form_submission, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { FileUpload } from "../../../../file_upload_pb.ts";
import { FormSubmission_Address, FormSubmission_BloodPressure, FormSubmission_Boolean, FormSubmission_Checklist, FormSubmission_Date, FormSubmission_DateTime, FormSubmission_Dosage, FormSubmission_Dropdown, FormSubmission_Email, FormSubmission_Frequency, FormSubmission_Markdown, FormSubmission_Number, FormSubmission_PainScale, FormSubmission_PhoneNumber, FormSubmission_RadioButton, FormSubmission_Rating, FormSubmission_Signature, FormSubmission_Text, FormSubmission_Time, FormSubmission_Weight } from "../../../../chat/form_submission_pb.ts";

/**
 * @generated from message qliq_protobuf.apps.pc.request.form_submission.CompleteForm
 */
export class CompleteForm extends Message<CompleteForm> {
  /**
   * @generated from field: uint32 form_submission_id = 1;
   */
  formSubmissionId = 0;

  /**
   * @generated from field: qliq_protobuf.apps.pc.request.form_submission.CompleteForm.Data data = 2;
   */
  data?: CompleteForm_Data;

  constructor(data?: PartialMessage<CompleteForm>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.apps.pc.request.form_submission.CompleteForm";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "form_submission_id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "data", kind: "message", T: CompleteForm_Data },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CompleteForm {
    return new CompleteForm().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CompleteForm {
    return new CompleteForm().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CompleteForm {
    return new CompleteForm().fromJsonString(jsonString, options);
  }

  static equals(a: CompleteForm | PlainMessage<CompleteForm> | undefined, b: CompleteForm | PlainMessage<CompleteForm> | undefined): boolean {
    return proto3.util.equals(CompleteForm, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.apps.pc.request.form_submission.CompleteForm.Data
 */
export class CompleteForm_Data extends Message<CompleteForm_Data> {
  /**
   * @generated from field: uint32 conversation_id = 1;
   */
  conversationId = 0;

  /**
   * @generated from field: qliq_protobuf.apps.pc.request.form_submission.CompleteForm.Data.Submission submission = 2;
   */
  submission?: CompleteForm_Data_Submission;

  /**
   * @generated from field: string iv = 3;
   */
  iv = "";

  /**
   * @generated from field: string key = 4;
   */
  key = "";

  /**
   * @generated from field: string key_alg = 5;
   */
  keyAlg = "";

  /**
   * @generated from field: optional uint32 reply_to_chat_message_id = 6;
   */
  replyToChatMessageId?: number;

  constructor(data?: PartialMessage<CompleteForm_Data>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.apps.pc.request.form_submission.CompleteForm.Data";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "conversation_id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "submission", kind: "message", T: CompleteForm_Data_Submission },
    { no: 3, name: "iv", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "key_alg", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "reply_to_chat_message_id", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CompleteForm_Data {
    return new CompleteForm_Data().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CompleteForm_Data {
    return new CompleteForm_Data().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CompleteForm_Data {
    return new CompleteForm_Data().fromJsonString(jsonString, options);
  }

  static equals(a: CompleteForm_Data | PlainMessage<CompleteForm_Data> | undefined, b: CompleteForm_Data | PlainMessage<CompleteForm_Data> | undefined): boolean {
    return proto3.util.equals(CompleteForm_Data, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.apps.pc.request.form_submission.CompleteForm.Data.Submission
 */
export class CompleteForm_Data_Submission extends Message<CompleteForm_Data_Submission> {
  /**
   * @generated from field: repeated qliq_protobuf.apps.pc.request.form_submission.CompleteForm.Data.Submission.Item items = 1;
   */
  items: CompleteForm_Data_Submission_Item[] = [];

  constructor(data?: PartialMessage<CompleteForm_Data_Submission>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.apps.pc.request.form_submission.CompleteForm.Data.Submission";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: CompleteForm_Data_Submission_Item, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CompleteForm_Data_Submission {
    return new CompleteForm_Data_Submission().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CompleteForm_Data_Submission {
    return new CompleteForm_Data_Submission().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CompleteForm_Data_Submission {
    return new CompleteForm_Data_Submission().fromJsonString(jsonString, options);
  }

  static equals(a: CompleteForm_Data_Submission | PlainMessage<CompleteForm_Data_Submission> | undefined, b: CompleteForm_Data_Submission | PlainMessage<CompleteForm_Data_Submission> | undefined): boolean {
    return proto3.util.equals(CompleteForm_Data_Submission, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.apps.pc.request.form_submission.CompleteForm.Data.Submission.FileUploadBulk
 */
export class CompleteForm_Data_Submission_FileUploadBulk extends Message<CompleteForm_Data_Submission_FileUploadBulk> {
  /**
   * @generated from field: repeated qliq_protobuf.FileUpload files = 1;
   */
  files: FileUpload[] = [];

  constructor(data?: PartialMessage<CompleteForm_Data_Submission_FileUploadBulk>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.apps.pc.request.form_submission.CompleteForm.Data.Submission.FileUploadBulk";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "files", kind: "message", T: FileUpload, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CompleteForm_Data_Submission_FileUploadBulk {
    return new CompleteForm_Data_Submission_FileUploadBulk().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CompleteForm_Data_Submission_FileUploadBulk {
    return new CompleteForm_Data_Submission_FileUploadBulk().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CompleteForm_Data_Submission_FileUploadBulk {
    return new CompleteForm_Data_Submission_FileUploadBulk().fromJsonString(jsonString, options);
  }

  static equals(a: CompleteForm_Data_Submission_FileUploadBulk | PlainMessage<CompleteForm_Data_Submission_FileUploadBulk> | undefined, b: CompleteForm_Data_Submission_FileUploadBulk | PlainMessage<CompleteForm_Data_Submission_FileUploadBulk> | undefined): boolean {
    return proto3.util.equals(CompleteForm_Data_Submission_FileUploadBulk, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.apps.pc.request.form_submission.CompleteForm.Data.Submission.Item
 */
export class CompleteForm_Data_Submission_Item extends Message<CompleteForm_Data_Submission_Item> {
  /**
   * @generated from field: string key = 1;
   */
  key = "";

  /**
   * @generated from oneof qliq_protobuf.apps.pc.request.form_submission.CompleteForm.Data.Submission.Item.value
   */
  value: {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Address address = 2;
     */
    value: FormSubmission_Address;
    case: "address";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.BloodPressure blood_pressure = 3;
     */
    value: FormSubmission_BloodPressure;
    case: "bloodPressure";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Boolean boolean = 4;
     */
    value: FormSubmission_Boolean;
    case: "boolean";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Checklist checklist = 5;
     */
    value: FormSubmission_Checklist;
    case: "checklist";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Date date = 6;
     */
    value: FormSubmission_Date;
    case: "date";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.DateTime date_time = 7;
     */
    value: FormSubmission_DateTime;
    case: "dateTime";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Dosage dosage = 8;
     */
    value: FormSubmission_Dosage;
    case: "dosage";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Dropdown dropdown = 9;
     */
    value: FormSubmission_Dropdown;
    case: "dropdown";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Email email = 10;
     */
    value: FormSubmission_Email;
    case: "email";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Frequency frequency = 11;
     */
    value: FormSubmission_Frequency;
    case: "frequency";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Number number = 12;
     */
    value: FormSubmission_Number;
    case: "number";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.PainScale pain_scale = 13;
     */
    value: FormSubmission_PainScale;
    case: "painScale";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.PhoneNumber phone_number = 14;
     */
    value: FormSubmission_PhoneNumber;
    case: "phoneNumber";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.RadioButton radio_button = 15;
     */
    value: FormSubmission_RadioButton;
    case: "radioButton";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Rating rating = 16;
     */
    value: FormSubmission_Rating;
    case: "rating";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Signature signature = 17;
     */
    value: FormSubmission_Signature;
    case: "signature";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Text text = 18;
     */
    value: FormSubmission_Text;
    case: "text";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Time time = 19;
     */
    value: FormSubmission_Time;
    case: "time";
  } | {
    /**
     * @generated from field: qliq_protobuf.apps.pc.request.form_submission.CompleteForm.Data.Submission.FileUploadBulk files_upload = 20;
     */
    value: CompleteForm_Data_Submission_FileUploadBulk;
    case: "filesUpload";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Weight weight = 21;
     */
    value: FormSubmission_Weight;
    case: "weight";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Markdown markdown = 22;
     */
    value: FormSubmission_Markdown;
    case: "markdown";
  } | {
    /**
     * @generated from field: qliq_protobuf.apps.pc.request.form_submission.CompleteForm.Data.Submission subform = 23;
     */
    value: CompleteForm_Data_Submission;
    case: "subform";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<CompleteForm_Data_Submission_Item>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.apps.pc.request.form_submission.CompleteForm.Data.Submission.Item";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "address", kind: "message", T: FormSubmission_Address, oneof: "value" },
    { no: 3, name: "blood_pressure", kind: "message", T: FormSubmission_BloodPressure, oneof: "value" },
    { no: 4, name: "boolean", kind: "message", T: FormSubmission_Boolean, oneof: "value" },
    { no: 5, name: "checklist", kind: "message", T: FormSubmission_Checklist, oneof: "value" },
    { no: 6, name: "date", kind: "message", T: FormSubmission_Date, oneof: "value" },
    { no: 7, name: "date_time", kind: "message", T: FormSubmission_DateTime, oneof: "value" },
    { no: 8, name: "dosage", kind: "message", T: FormSubmission_Dosage, oneof: "value" },
    { no: 9, name: "dropdown", kind: "message", T: FormSubmission_Dropdown, oneof: "value" },
    { no: 10, name: "email", kind: "message", T: FormSubmission_Email, oneof: "value" },
    { no: 11, name: "frequency", kind: "message", T: FormSubmission_Frequency, oneof: "value" },
    { no: 12, name: "number", kind: "message", T: FormSubmission_Number, oneof: "value" },
    { no: 13, name: "pain_scale", kind: "message", T: FormSubmission_PainScale, oneof: "value" },
    { no: 14, name: "phone_number", kind: "message", T: FormSubmission_PhoneNumber, oneof: "value" },
    { no: 15, name: "radio_button", kind: "message", T: FormSubmission_RadioButton, oneof: "value" },
    { no: 16, name: "rating", kind: "message", T: FormSubmission_Rating, oneof: "value" },
    { no: 17, name: "signature", kind: "message", T: FormSubmission_Signature, oneof: "value" },
    { no: 18, name: "text", kind: "message", T: FormSubmission_Text, oneof: "value" },
    { no: 19, name: "time", kind: "message", T: FormSubmission_Time, oneof: "value" },
    { no: 20, name: "files_upload", kind: "message", T: CompleteForm_Data_Submission_FileUploadBulk, oneof: "value" },
    { no: 21, name: "weight", kind: "message", T: FormSubmission_Weight, oneof: "value" },
    { no: 22, name: "markdown", kind: "message", T: FormSubmission_Markdown, oneof: "value" },
    { no: 23, name: "subform", kind: "message", T: CompleteForm_Data_Submission, oneof: "value" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CompleteForm_Data_Submission_Item {
    return new CompleteForm_Data_Submission_Item().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CompleteForm_Data_Submission_Item {
    return new CompleteForm_Data_Submission_Item().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CompleteForm_Data_Submission_Item {
    return new CompleteForm_Data_Submission_Item().fromJsonString(jsonString, options);
  }

  static equals(a: CompleteForm_Data_Submission_Item | PlainMessage<CompleteForm_Data_Submission_Item> | undefined, b: CompleteForm_Data_Submission_Item | PlainMessage<CompleteForm_Data_Submission_Item> | undefined): boolean {
    return proto3.util.equals(CompleteForm_Data_Submission_Item, a, b);
  }
}

